'use client';

import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { store } from '@/store';
import { UserProvider } from '../components/userContext';
import dynamic from 'next/dynamic';
import { useAOS } from '@/hooks/useAOS';
import AnimationPauser from '@/components/AnimationPauser';

const MotionProvider = dynamic(() => import('./MotionProvider'));

const Providers = ({ children }: { children: React.ReactNode }) => {
  useAOS(); // global scroll-reveal for [data-aos] elements (replaces the AOS library)
  return (
    <>
      <Provider store={store}>
        <UserProvider>
          <MotionProvider>
          {children}
          </MotionProvider>
        </UserProvider>
      </Provider>
      <AnimationPauser />
      <Toaster />
    </>
  );
};

export default Providers;
